import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { OrganizationAttributesPage } from '@apps/web/features/admin_organization_attributes';

export const Route = createFileRoute(
    '/_app/admin/organization-attributes/$tab/{-$organizationId}',
)({
    params: {
        parse: (params) => ({
            ...params,
            tab: z
                .enum([
                    'attributes-and-preferences',
                    'rules',
                    'minting',
                    'suggestions',
                ])
                .parse(params.tab),
        }),
    },
    component: OrganizationAttributesPage,
    head: () => ({
        meta: [{ title: 'Organization Attributes | Phoebe Admin' }],
    }),
});
